import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs, Tooltip } from 'antd';
import { FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import EventEmitter from '../../../utils/eventEmitter';
import usePackagesAPI from '../../apis/packagesAPI';
import dayjs from 'dayjs';


const PackageChanges = () => {
  const {products, locations, packageTypes, packageProduct} = useLoaderData();
  packageProduct['pack_date'] = packageProduct.pack_date ? dayjs(packageProduct['pack_date'], 'YYYY-MM-DD') : '';
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState(packageProduct.name ? packageProduct.name : '');
  const { create, update } = usePackagesAPI();
  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['pack_date'] = new Date(data['pack_date']).toLocaleDateString();
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    create(data, success);
    // console.log(data);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    update(packageProduct.seo, data, success);
    // console.log(data)
  };

  const handleDiscard = () => { };


  useEffect(() => {
    EventEmitter.subscribe('package_created', data => {
      navigate('/inventory/packages/'+data);
    });

    return () => {
      EventEmitter.unsubscribe('package_created');
    }
  },[])


  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/inventory/packages'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Packages</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ packageProduct.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
        </div>
        {packageProduct.seo && <Button onClick={edit}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Package Reference"
          value={name} 
          onChange={onChangeName}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 8 }}
          labelWrap={true}
          initialValues={packageProduct.seo ? packageProduct : {}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Row className='mt-5'>
            <Col md={{ span: 11 }}>
              <Form.Item label='Package Type' name='package_type_id' className='font-semibold text-gray-800 mb-4' required >
                <Select options={packageTypes.map(packageType => ({value: packageType.id, label: packageType.name}))}/>
              </Form.Item>
              <Form.Item label='Shipping Weight' name='shipping_weight' className='font-semibold text-gray-800 mb-4' required >
                <InputNumber className='border-x-0 border-t-0 input-outline-none font-normal w-full' addonAfter="kg"/>
              </Form.Item>     
              <Form.Item label='Locations' name='location_id' className='font-semibold text-gray-800 mb-4' required >
                <Select options={locations.map(location => ({value: location.id, label: location.name}))}/>
              </Form.Item>
            </Col>
            <Col md={{ span: 10, offset: 1 }}>
              <Form.Item labelCol={{span: 10}} label='Pack Date' name={'pack_date'} className='font-semibold text-gray-800 mb-4' required>
                <DatePicker />  
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}

export default PackageChanges;